import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlayerScoreService {

  private _score: number = 0;
  private _tries: number = 0;

  private _resources: number = 0;
  public get resources(): number {
    return this._resources;
  }
  public set resources(v: number) {
    if (!v) v = 0;
    this.updateAnimated(this._resources, v, this.resObs);
    this._resources = v;
  }

  public scoreObs: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public triesObs: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public resObs: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get score(): number {
    return this._score;
  }
  public set score(v: number) {
    if (!v) v = 0;
    this.updateAnimated(this._score, v, this.scoreObs);
    this._score = v;
  }
  public get tries(): number {
    return this._tries;
  }
  public set tries(r: number) {
    if (!r) r = 0;
    this.updateAnimated(this._tries, r, this.triesObs);
    this._tries = r;

  }

  private updateAnimated(start: number, to: number, obs: BehaviorSubject<number>) {
    let part = Math.floor((to - start) / 15);
    let step = start;
    const animationInterval = setInterval(() => {
      if (step + part <= to) {
        obs.next(step += part);
      } else {
        step = to;
        obs.next(to);
      }
      if (step == to) {
        clearInterval(animationInterval);
      }
    }, 100);
  }

  constructor() {
    let v = localStorage.getItem("p_score");
    if (!v) {
      this.score = 0;
      this.tries = 200;
      this.resources = 100000;
      this.saveScore();
    } else {
      let d = JSON.parse(v);
      this._score = d.score;
      this._tries = d.tries;
      this._resources = d.resources;
      this.scoreObs.next(this.score)
      this.resObs.next(this.resources)
      this.triesObs.next(this.tries)
    }

  }

  public saveScore() {
    localStorage.setItem("p_score", JSON.stringify({ score: this._score, tries: this._tries, resources: this._resources }));
  }
  public addScore(v: number) {
    this.score += v;
    this.saveScore();
  }
  public addTries(v: number) {
    this.tries += v;
    this.saveScore();
  }
  public addResources(v: number) {
    this.resources += v;
    this.saveScore();
  }
}
